import { render, staticRenderFns } from "./aliPuzzle.vue?vue&type=template&id=135c84a4&"
import script from "./aliPuzzle.vue?vue&type=script&lang=js&"
export * from "./aliPuzzle.vue?vue&type=script&lang=js&"
import style0 from "./aliPuzzle.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports